import { collection, getCountFromServer, query, QueryFieldFilterConstraint, where } from 'firebase/firestore';
import { JobType } from '@leedpulse-monorepo/enums';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';

/**
 * Number of scheduled messages among the jobs a query selects. `Jobs` also holds the contact
 * workflow jobs (type `workflow`, backend helpers/workflows), which are not messages: they are
 * counted apart and taken out, so that every other job is counted exactly as before.
 *
 * @param constraints - Field filters of the count (none: every job)
 */
async function countScheduledMessages(constraints: QueryFieldFilterConstraint[] = []): Promise<number> {
  try {
    const jobsCollection = collection(firestore, FirestoreCollections.jobs);
    const [allSnapshot, workflowsSnapshot] = await Promise.all([
      getCountFromServer(query(jobsCollection, ...constraints)),
      getCountFromServer(query(jobsCollection, ...constraints, where('type', '==', JobType.workflow))),
    ]);
    return (allSnapshot.data().count ?? 0) - (workflowsSnapshot.data().count ?? 0);
  } catch (e) {
    console.log('error: ', e);
    throw new CountScheduledMessagesFailure();
  }
}

export class CountScheduledMessagesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default countScheduledMessages;
